import { css, html } from 'react-strict-dom';
import { color } from 'src/constants/color.css';

import { Api } from '../api';
import Text from './Text';

type Props = Readonly<{
  user: Api.User.BaseView | Api.User.V_Self | null | undefined;
  size?: number;
  style?: css.StyleXStyles;
}>;

export default function Avatar({ user, size = 32, style }: Props) {
  return (
    <html.div style={[styles.container, styles.size(size), style]}>
      {user &&
        (user.agencyRole ? (
          <html.img
            style={styles.img}
            src={`/img/avatars/${user.firstName
              .toLowerCase()
              .replace(/ /g, '')}_${user.lastName.toLowerCase()}.jpg`}
          />
        ) : (
          <Text
            as="div"
            bold
            style={[styles.initials, styles.initialsFont(size)]}
          >
            {`${user.firstName.substr(0, 1)}${user.lastName.substr(
              0,
              1
            )}`.toUpperCase()}
          </Text>
        ))}
    </html.div>
  );
}

const styles = css.create({
  container: {
    borderRadius: '50%',
    overflow: 'hidden',
    backgroundColor: color.neutral100,
    display: 'inline-block',
  },
  size: (size: number) => ({
    width: size,
    height: size,
  }),
  img: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  initials: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    textAlign: 'center',
    color: '#fff',
    fontWeight: '600',
  },
  initialsFont: (size: number) => ({
    fontSize: size * 0.4,
  }),
});
